/**
 * This constant is needed to save memory. We don't want infinite events stored in memory.
 */
export const MAX_USER_EVENTS_RETAINED_IN_STORE = 10;
